/**
 * TanStack Query Client Configuration
 * 
 * Configures global query settings including cache times,
 * retry logic, and error handling.
 */

import { QueryClient } from '@tanstack/react-query';
import { APIError } from './api/client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: 5 minutes for list queries (can be overridden per query)
      staleTime: 5 * 60 * 1000,
      
      // Cache time: 30 minutes (data kept in cache after becoming stale)
      gcTime: 30 * 60 * 1000,
      
      // Refetch on window focus
      refetchOnWindowFocus: true,
      
      // Refetch on reconnect
      refetchOnReconnect: true,
      
      // Retry failed requests with exponential backoff
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors (client errors)
        if (error instanceof APIError && error.status >= 400 && error.status < 500) {
          return false;
        }
        
        // Retry up to 3 times for other errors
        return failureCount < 3;
      },
      
      // Exponential backoff delay
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      // Retry mutations once on failure
      retry: 1,
      
      // Exponential backoff for mutations
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});
